import { render } from "./DeductionPerHour.vue?vue&type=template&id=72f88ee4&scoped=true"
import script from "./DeductionPerHour.vue?vue&type=script&lang=js"
export * from "./DeductionPerHour.vue?vue&type=script&lang=js"

import "./DeductionPerHour.vue?vue&type=style&index=0&id=72f88ee4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72f88ee4"]])

export default __exports__